import React, { useEffect, useState } from 'react';
import { FileUpload } from './components/FileUpload';
import { AxisManagement } from './components/AxisManagement';
import { ScaleConfig } from './components/ScaleConfig';
import { Analysis } from './components/Analysis';
import { Dashboard } from './components/Dashboard';
import { Export } from './components/Export';
import { Instructions } from './components/Instructions';
import { Sidebar } from './components/Sidebar';

import { LandingPage } from './components/LandingPage';
import { UserMenu } from './components/UserMenu';
import { useStore } from './store';
import { supabase } from './lib/supabase';

function App() {
  const [session, setSession] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState(false);
  const currentPage = useStore(state => state.currentPage);

  useEffect(() => {
    // Check initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(!!session);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'file_upload':
        return <FileUpload />;
      case 'axis_management':
        return <AxisManagement />;
      case 'scale_config':
        return <ScaleConfig />;
      case 'analysis':
        return <Analysis />;
      case 'dashboard':
        return <Dashboard />;
      case 'export':
        return <Export />;
      case 'instructions':
        return <Instructions />;
      default:
        return <FileUpload />;
    }
  };

  if (!session) {
    return <LandingPage />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex" dir="rtl">
      <Sidebar />
      <main className={`flex-1 transition-all duration-300 ${isMobile ? 'mr-0' : 'md:mr-64'}`}>
        {/* Modern Header - Enhanced for mobile */}
        <div className={`glass-card m-2 md:m-6 p-3 md:p-6 mb-4 md:mb-6 ${isMobile ? 'mt-16' : ''}`}>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="order-2 md:order-1 w-full md:w-auto">
              <h1 className="text-lg md:text-3xl font-bold gradient-text text-right">
                محلل استبانات ورش العمل التدريبية 📊
              </h1>
              <p className="text-gray-600 text-right mt-2 text-xs md:text-base">
                نظام تحليل متقدم مع ذكاء اصطناعي لتحليل بيانات الاستبانات
              </p>
            </div>
            <div className="order-1 md:order-2 w-full md:w-auto flex justify-end">
              <UserMenu />
            </div>
          </div>
        </div>

        {/* Page Content - Enhanced for mobile */}
        <div className="w-full overflow-x-auto px-2 md:px-0">
          <div className="min-h-[calc(100vh-200px)]">
            {renderPage()}
          </div>
        </div>

        {/* Modern Footer - Enhanced for mobile */}
        <footer className="m-2 md:m-6 mt-4 md:mt-12">
          <div className="glass-card p-3 md:p-4 text-center">
            <p className="text-gray-600 text-xs md:text-sm">
              تم التطوير بواسطة <span className="font-semibold gradient-text-secondary">أسامة صبري الطيطي</span>
            </p>
            <p className="text-gray-500 text-xs mt-1">
              مركز التعلم الإلكتروني - جامعة الإسراء
            </p>
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;